import { PawPrint, Sparkles, UserPlus, LayoutDashboard, Heart } from "lucide-react";
import shareCardBg from "@/assets/share-card-bg.png";

interface Props {
  backgroundDataUrl?: string;
}

/**
 * Story Owner Panel 1: "Nowość dla schronisk" - 3 korzyści (konto, panel, bezpłatnie)
 */
export const InstagramStoryOwnerPanel1 = ({ backgroundDataUrl }: Props) => {
  const bgImage = backgroundDataUrl || shareCardBg;

  return (
    <div
      style={{
        width: "1080px",
        height: "1920px",
        fontFamily: "'Nunito', sans-serif",
        display: "flex",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        backgroundColor: "#1a3a2a",
      }}
    >
      <img
        src={bgImage}
        alt=""
        draggable={false}
        data-export-bg="true"
        loading="eager"
        decoding="sync"
        style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", objectFit: "cover", zIndex: 0 }}
      />
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "8px", background: "linear-gradient(90deg, #4E8A6E 0%, #6BAF8D 50%, #4E8A6E 100%)", zIndex: 2 }} />

      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: "150px 72px 80px",
          position: "relative",
          zIndex: 1,
        }}
      >
        {/* Badge NOWOŚĆ */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "12px",
            background: "#2D5A3D",
            padding: "14px 28px",
            borderRadius: "999px",
            marginBottom: "28px",
            boxShadow: "0 8px 24px rgba(45,90,61,0.25)",
          }}
        >
          <Sparkles style={{ width: "26px", height: "26px", color: "#FFFFFF" }} />
          <span style={{ fontSize: "26px", fontWeight: 800, color: "#FFFFFF", letterSpacing: "0.08em", textTransform: "uppercase" }}>
            Nowość dla schronisk
          </span>
        </div>

        <h1 style={{ fontSize: "84px", fontWeight: 900, color: "#2D5A3D", margin: "0 0 18px", textAlign: "center", lineHeight: 1.05, letterSpacing: "-0.02em" }}>
          Załóż konto<br />i zarządzaj sam
        </h1>
        <p style={{ fontSize: "36px", fontWeight: 600, color: "#4A7A5E", margin: "0 0 48px", textAlign: "center", lineHeight: 1.3, maxWidth: "900px" }}>
          Wolontariusz albo pracownik schroniska - od teraz każdy może aktualizować potrzeby 💚
        </p>

        {/* 3 benefit cards */}
        <div style={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%", maxWidth: "920px" }}>
          <div style={{ background: "rgba(255,255,255,0.96)", borderRadius: "28px", padding: "28px 36px", boxShadow: "0 6px 20px rgba(0,0,0,0.08)", display: "flex", alignItems: "center", gap: "24px" }}>
            <div style={{ background: "#E8F4ED", borderRadius: "20px", width: "84px", height: "84px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <UserPlus style={{ width: "44px", height: "44px", color: "#2D5A3D" }} />
            </div>
            <div>
              <p style={{ fontSize: "34px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 4px", lineHeight: 1.2 }}>
                Załóż konto w 2 minuty
              </p>
              <p style={{ fontSize: "26px", fontWeight: 600, color: "#5A8A70", margin: 0, lineHeight: 1.3 }}>
                Bez papierów, bez czekania
              </p>
            </div>
          </div>

          <div style={{ background: "rgba(255,255,255,0.96)", borderRadius: "28px", padding: "28px 36px", boxShadow: "0 6px 20px rgba(0,0,0,0.08)", display: "flex", alignItems: "center", gap: "24px" }}>
            <div style={{ background: "#E8F4ED", borderRadius: "20px", width: "84px", height: "84px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <LayoutDashboard style={{ width: "44px", height: "44px", color: "#2D5A3D" }} />
            </div>
            <div>
              <p style={{ fontSize: "34px", fontWeight: 800, color: "#2D5A3D", margin: "0 0 4px", lineHeight: 1.2 }}>
                Panel organizacji
              </p>
              <p style={{ fontSize: "26px", fontWeight: 600, color: "#5A8A70", margin: 0, lineHeight: 1.3 }}>
                Aktualizuj potrzeby kiedy chcesz
              </p>
            </div>
          </div>

          <div style={{ background: "#2D5A3D", borderRadius: "28px", padding: "28px 36px", boxShadow: "0 8px 28px rgba(45,90,61,0.3)", display: "flex", alignItems: "center", gap: "24px" }}>
            <div style={{ background: "rgba(255,255,255,0.18)", borderRadius: "20px", width: "84px", height: "84px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
              <Heart style={{ width: "44px", height: "44px", color: "#FFFFFF" }} />
            </div>
            <div>
              <p style={{ fontSize: "34px", fontWeight: 800, color: "#FFFFFF", margin: "0 0 4px", lineHeight: 1.2 }}>
                100% bezpłatnie
              </p>
              <p style={{ fontSize: "26px", fontWeight: 600, color: "#D1FAE5", margin: 0, lineHeight: 1.3 }}>
                Bez prowizji, bez ukrytych kosztów
              </p>
            </div>
          </div>
        </div>

        <p style={{ fontSize: "30px", fontWeight: 700, color: "#2D5A3D", margin: "44px 0 0", textAlign: "center" }}>
          Wejdź na gdzieschronisko.pl 👇
        </p>
      </div>

      <div style={{ padding: "0 80px 100px", display: "flex", justifyContent: "center", position: "relative", zIndex: 1 }}>
        <div style={{ display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ background: "#4E8A6E", borderRadius: "14px", width: "52px", height: "52px", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <PawPrint style={{ width: "28px", height: "28px", color: "#FFFFFF" }} />
          </div>
          <span style={{ fontSize: "28px", fontWeight: 700, color: "#2D5A3D" }}>gdzieschronisko.pl</span>
        </div>
      </div>
    </div>
  );
};
